import axios, { LONG_TIMEOUT_MS } from "utils/axios";

// schedule admin
export const getMSScheduleAdmins = (params) => {
  return axios.get(`/WA/meeting-schedules/schedule-admins`, {
    params,
  });
};

export const postMSScheduleAdmins = (payload) => {
  return axios.post(`/WA/meeting-schedules/schedule-admins`, payload);
};

export const putMSScheduleAdmins = ({ id, payload }) => {
  return axios.put(`/WA/meeting-schedules/schedule-admins/${id}`, payload);
};

export const deleteMSScheduleAdmins = (id) => {
  return axios.delete(`/WA/meeting-schedules/schedule-admins/${id}`);
};

// admin groups
export const getMSGroupAdmins = (params) => {
  return axios.get(`/WA/meeting-schedules/admin-groups`, {
    params,
  });
};

export const postMSGroupAdmins = (payload) => {
  return axios.post(`/WA/meeting-schedules/admin-groups`, payload);
};

export const putMSGroupAdmins = ({ id, payload }) => {
  return axios.put(`/WA/meeting-schedules/admin-groups/${id}`, payload);
};

export const deleteMSGroupAdmins = (id) => {
  return axios.delete(`/WA/meeting-schedules/admin-groups/${id}`);
};

export const getMSGroupAdminsInfinite = (params) => {
  return axios.get(`/WA/meeting-schedules/admin-groups`, {
    params,
  });
};

// weekends
export const getMSWeekends = (payload) => {
  return axios.get(`/WA/meeting-schedules/weekends`, {
    params: payload, // {sort_by:#, order_by:#}
  });
};

export const postMSWeekends = (payload) => {
  return axios.post(`/WA/meeting-schedules/weekends`, payload);
};

export const deleteMSWeekends = (id) => {
  return axios.delete(`/WA/meeting-schedules/weekends/${id}`);
};

// weekdays

export const getMSWeekdays = () => {
  return axios.get(`/WA/meeting-schedules/weekdays`);
};

export const postMSWeekdays = (payload) => {
  return axios.post(`/WA/meeting-schedules/weekdays`, payload);
};

// meeting schedule calendar

export const getMSCalendarMonth = ({ month, schedule_admin_id }) => {
  return axios.get(`/WA/meeting-schedules/calendars/month/${month}`, {
    params: {
      schedule_admin_id,
    },
  });
};

export const getMSCalendarDay = ({ day, schedule_admin_id }) => {
  return axios.get(`/WA/meeting-schedules/calendars/date/${day}`, {
    params: {
      schedule_admin_id,
    },
  });
};

export const setMSCalendarAvailable = ({ date, ...payload }) => {
  return axios.post(
    `/WA/meeting-schedules/calendars/date/${date}/setAvailability`,
    payload
  );
};

export const setMSCalendarAvailableAll = ({ date, ...payload }) => {
  return axios.post(
    `/WA/meeting-schedules/calendars/date/${date}/setAllAvailability`,
    payload
  );
};

export const getMSScheduleDetail = (id) => {
  return axios.get(`/WA/meeting-schedules/${id}`);
};

export const deleteMSSchedule = (id) => {
  return axios.delete(`/WA/meeting-schedules/${id}`);
};

export const getMSSchedules = (params) => {
  return axios.get(`/WA/meeting-schedules`, {
    params,
  });
};

export const postMSSchedules = (payload) => {
  return axios.post(`/WA/meeting-schedules`, payload);
};

export const putMSSchedules = ({ id, ...payload }) => {
  return axios.put(`/WA/meeting-schedules/${id}`, payload);
};

export const patchMSScheduleNote = ({ id, note }) => {
  return axios.patch(`/WA/meetingSchedules/${id}/note`, { note });
};

export const getMSScheduleStatuses = (params) => {
  return axios.get(`/WA/meetingSchedules/statuses`, {
    params,
  });
};

export const patchMSScheduleStatus = ({
  id,
  status_id,
  report,
  company_id,
  app_id,
}) => {
  return axios.patch(`/WA/meetingSchedules/${id}/status`, {
    status_id,
    ...(report != null ? { report } : {}),
    ...(company_id != null ? { company_id } : {}),
    ...(app_id != null ? { app_id } : {}),
  });
};

// laporan meeting → WhatsApp ke customer (draft AI + kirim)
export const postMSReportWhatsappDraft = ({ id, report_override }) => {
  return axios.post(
    `/WA/meetingSchedules/${id}/reportWhatsappDraft`,
    report_override != null ? { report_override } : {}
  );
};

// points = array poin hasil diskusi (1–8 item, tiap item ≤ 75 char). Sapaan,
// nama, perusahaan, dan padding slot sisa dirakit backend dari template.
export const postMSReportWhatsappSend = ({ id, points }) => {
  return axios.post(`/WA/meetingSchedules/${id}/reportWhatsappSend`, {
    points,
  });
};

export const exportMSSchedules = (params) => {
  return axios.get(`/WA/meeting-schedules`, {
    params: { ...params, export: "xls" },
    responseType: "blob",
    timeout: LONG_TIMEOUT_MS,
  });
};

// meeting schedule availability (auto select agent)
export const getMSAvailableSlots = (params) => {
  return axios.get(`/WA/meetingSchedules/availability/slots`, { params });
};

export const getMSPriorityAgent = (params) => {
  return axios.get(`/WA/meetingSchedules/availability/agent`, { params });
};

// meeting schedule tags (master)
export const getMSScheduleTags = (params) => {
  return axios.get(`/WA/meetingScheduleTags`, { params });
};

export const postMSScheduleTags = (payload) => {
  return axios.post(`/WA/meetingScheduleTags`, payload);
};

export const patchMSScheduleTags = ({ id, tag_ids }) => {
  return axios.patch(`/WA/meetingSchedules/${id}/tags`, { tag_ids });
};
